import { ExecutionStatusEnum, getFragmentData } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { AlertMessages } from '../../AlertMessages';

import { Content } from './Result';
import { ServiceUsagesTotalCardCmp_TotalCalculation_Fragment } from '.';

interface Props {
  readonly totalCalculation: FragmentType<
    typeof ServiceUsagesTotalCardCmp_TotalCalculation_Fragment
  >;
}

export const ServiceUsagesTotalContent = ({
  totalCalculation: pTotalCalculation,
}: Readonly<Props>) => {
  const { automaticResult, details, result, status, totalMode } =
    getFragmentData(
      ServiceUsagesTotalCardCmp_TotalCalculation_Fragment,
      pTotalCalculation,
    );

  return status === ExecutionStatusEnum.Ko ? (
    <AlertMessages
      messages={details.map((detail) => detail.fr)}
      severity="error"
    />
  ) : (
    <Content
      automaticResult={automaticResult}
      result={result}
      totalMode={totalMode}
    />
  );
};
